export default "__VITE_ASSET__DvDC91PO__"